import { Collapse } from "antd";
import React, { useMemo } from "react";
import {
	IOrganizationTrainingSummary,
	IOrganizationUserTrainingSummary,
	IUserTrainingSummary,
} from "src/@types/ImpiricaPlatformApi";
import { useApi } from "src/Api/useApi";
import TrainingSummaryHeader from "./TrainingSummaryHeader";
import TrainingSummaryCourse from "./TrainingSummaryCourse";
import styles from "./TrainingSummaryList.module.scss";
import { Spinner } from "src/components/common";
type TrainingSummaryListProps = {
	organizationId: number;
	orgTrainingSummary: IOrganizationTrainingSummary;
	showAll?: boolean;
};

const { Panel } = Collapse;

const TrainingSummaryList: React.FC<TrainingSummaryListProps> = ({
	organizationId,
	orgTrainingSummary,
	showAll,
}) => {
	const [userTrainingDetails, setUserTrainingDetails] = React.useState<
		Record<number, IUserTrainingSummary>
	>({});
	const [loading, setLoading] = React.useState(false);
	const { trainingCourseClient } = useApi();

	const handlePanelChange = async (key: string | string[]) => {
		const userId = parseInt(key as string);
		setLoading(true);
		if (trainingCourseClient && !Number.isNaN(userId)) {
			try {
				const userTrainingSummary =
					await trainingCourseClient.getUserTrainingSummary(userId);
				const tempDetails = JSON.parse(JSON.stringify(userTrainingDetails));
				tempDetails[userId] = userTrainingSummary;

				setUserTrainingDetails(tempDetails);
			} catch (error) {
				console.error(error);
			}
		}
		setLoading(false);
	};

	const summariesToShow = useMemo(() => {
		const users = orgTrainingSummary.users || [];
		return showAll ? users : users.filter((user) => user.isActive);
	}, [orgTrainingSummary, showAll]);

	return (
		<div className={styles.container}>
			<Collapse
				accordion
				className="custom-collapse"
				expandIconPosition="right"
				onChange={handlePanelChange}
			>
				{summariesToShow &&
					summariesToShow.map(
						(userSummary: IOrganizationUserTrainingSummary) =>
							userSummary.courses &&
							userSummary.name && (
								<Panel
									key={userSummary.userId}
									header={
										<TrainingSummaryHeader
											courses={userSummary.courses}
											name={userSummary.name}
										/>
									}
								>
									{loading ? (
										<div className={styles.spinner}>
											<Spinner />
										</div>
									) : (
										userSummary.courses && (
											<TrainingSummaryCourse
												organizationId={organizationId}
												userId={userSummary.userId}
												courseDetails={userTrainingDetails[userSummary.userId]}
												key={userSummary.userId}
											/>
										)
									)}
								</Panel>
							)
					)}
			</Collapse>
		</div>
	);
};
export default TrainingSummaryList;
